import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Customer } from 'src/app/Models/Customer';
import { CommonUtilities } from 'src/assets/js/common-utilities';
// import * as ace from "ace-builds";
import { CustomExceptionService } from 'src/app/errorHandlers/custom-exception.service';
import { usererrors } from 'src/app/errors/usererrors';
import { Metadatum } from 'src/app/Models/metadatum';
import { CustomerService } from 'src/app/Services/customer.service';
import { RadioButton } from 'primeng/radiobutton';
import { vCustomersite } from 'src/app/Validators/validation';
import { KeyPress } from 'src/assets/js/KeyPress';
import { ExportUtility } from 'src/assets/js/export-utility';

declare var $: any;

@Component({
  selector: 'app-c-customer',
  templateUrl: './c-customer.component.html',
  styleUrls: ['./c-customer.component.css']
})
export class CCustomerComponent implements OnInit {
  _Customerform: FormGroup;
  _IsProgressSpinner: boolean = false;
  _Customer: Customer
  transporter: string
  ManageCustomersList: any[]
  _BillingCycle: any
  id: any
  _CompanyType: any
  _QuoteStatus: any[]
  _Status: any[]
  hideStatus: boolean = true
  _Transporter: Metadatum[] = [] 
  addressRowIndex: number = -1;
  _Tempvariable: number = 0
  _submitted: boolean = false;
  CustomerList: any[]
  cols: any[];
  @ViewChild("editor", { static: true }) private editor: ElementRef<HTMLElement>;
  constructor(private fb: FormBuilder, private router: Router, private utility: CommonUtilities, private _CustomerService: CustomerService,
    private _CustomExceptionService: CustomExceptionService,public keypress: KeyPress,public exportUtility: ExportUtility) { }

    InitializeForm(){
      this._Customerform = this.fb.group({
        customercode: [],
        customername: ['',vCustomersite],
        companytypecode: ['',vCustomersite],
        companytype: [],
        tallyid: [],
        pan: [],
        billingcyclecode: ['',vCustomersite],
        billingcycle: [],
        istransportercode: ['',vCustomersite],
        istransporter: [],
        prequotestatuscode: [],
        prequotestatus: [],
        recordstatuscode: [],
        recordstatus: [],
        createdby: [],
        createdon: [],
        modifiedby: [],
        modifiedon: [],
        accountingyear: [],
      });
      this._Customerform.get("recordstatuscode").setValue("MSC00001");
    this._Customerform.get("istransportercode").setValue("MSC00012");
    }
  ngOnInit(): void {

    this.utility.pageLoadScript();
    this.cols = [
      { field: 'customername', header: 'Customer Name' },
      { field: 'tallyid', header: 'Customer Tally ID' },
      { field: 'companytype', header: 'Company Type' },
      { field: 'istransporter', header: 'Is Transporter' },
      { field: 'pan', header: 'PAN No' },
      { field: 'billingcycle', header: 'Billing Cycle' },
      { field: 'recordstatus', header: 'Status' },

    ]
    this.InitializeForm()
    this._IsProgressSpinner = true;
    this._CustomerService.GetPageInitializeDetails().subscribe((result) => {
      this._IsProgressSpinner = false;
      const resultJSON = JSON.parse(JSON.stringify(result));
      // console.log(resultJSON);
      this._BillingCycle = resultJSON.lstBillingcycle
      this._Transporter = resultJSON.lstYesNo
      this._CompanyType = resultJSON.lstCompanyType
      this._Status = resultJSON.lstRecordstatus
      this.ManageCustomersList = resultJSON.lstCustomer


    }, error => { this._CustomExceptionService.handleError(error); }
    );
    this._Customerform.get("recordstatuscode").setValue("MSC00001");
    this._Customerform.get("istransportercode").setValue("MSC00012");

  }
  getTransporter(event,control:RadioButton){
    
    $("input[name='" + control.name + "']").prop('checked',false);
    control.checked = true;

  }
  onRowCustomerselect(_ManageCustomerList: Customer, rowIndex: number) {
    this.hideStatus = false
    this._Tempvariable = 1
    // var code = this.ManageCustomersList.filter(f=>f.companytype)[0].companytypecode
    // console.log("bh", _ManageCustomerList);
    this._Customerform.setValue(_ManageCustomerList);
    // this.addressRowIndex = rowIndex;
    // var compcode = _ManageCustomerList.companytypecode
    // var billcode = _ManageCustomerList.billingcyclecode
    // var statuscode = _ManageCustomerList.recordstatuscode
    // console.log(compcode);
    // console.log(billcode);


    // this._Customerform.get("companytypecode").setValue(this._CompanyType.find(f => f.metasubcode === compcode));
    // this._Customerform.get("billingcyclecode").setValue(this._BillingCycle.find(f => f.metasubcode === billcode));
    // this._Customerform.get("recordstatuscode").setValue(this._Status.find(f => f.metasubcode === statuscode));

  }
  onSave() {
    // console.log(this._Customerform.get("companytypecode").value)
    // console.log(this._Customerform.get("billingcyclecode").value)
    this._submitted = true
    if (this._Customerform.valid) {
      // this._submitted = false
      this._Customer = this._Customerform.value;
      if (this._Tempvariable == 0) {
        // console.log("IN");

        this._Customer.createdon = new Date();
        this._Customer.createdby = "ADMIN";
        this._Customer.modifiedon = new Date();
        // this._Customer.accountingyear = new Date().getFullYear();
        this._Customer.companytypecode = this._Customerform.get("companytypecode").value;
        // alert(this._Customerform.get("companytypecode").value)
        this._Customer.billingcyclecode = this._Customerform.get("billingcyclecode").value;
        // this.onEd();
        this._CustomerService.InsertCustomer(this._Customer).subscribe((result) => {
          const resutJSON = JSON.parse(JSON.stringify(result));
          // console.log("save", resutJSON)
          if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
            this._CustomExceptionService.handleSuccess(usererrors.Saved_Success_00);
            this.ManageCustomersList = resutJSON.lstCustomer
            this.reset()
          }
          else {
            this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
          }
        }, error => { this._CustomExceptionService.handleError(error) }

        );
      }
      if (this._Tempvariable == 1) {
        // console.log("IN");
  
        // this._Customer.createdon = new Date();
        this._Customer.createdby = "ADMIN";
        this._Customer.modifiedby = "ADMIN";
        // this._Customer.modifiedon = new Date();
        // this._Customer.accountingyear = null;
        this._Customer.companytypecode = this._Customerform.get("companytypecode").value;
        this._Customer.billingcyclecode = this._Customerform.get("billingcyclecode").value;
        this._Customer.recordstatuscode = this._Customerform.get("recordstatuscode").value;
        // this.onEd();
        this._CustomerService.UpdateCustomer(this._Customer).subscribe((result) => {
          const resutJSON = JSON.parse(JSON.stringify(result));
          // console.log("EDIT", resutJSON)
          if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
            this._CustomExceptionService.handleSuccess(usererrors.Update_Success_04);
            this.ManageCustomersList = resutJSON.lstCustomer
            this.reset()
          }
          else {
            this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
          }
        }, error => { this._CustomExceptionService.handleError(error) }
  
        );
      }
    }
    
  }


// }
reset(){
  this.hideStatus = true
  this._submitted = false
  // this._Customerform.reset()
  this.InitializeForm()
}
goBack(event){
  this.router.navigate(['/vCustomer']);
}
// onEd() {
//   alert("test");
//   ace.config.set("fontSize", "14px");
//   ace.config.set('basePath', 'https://unpkg.com/ace-builds@1.4.12/src-noconflict');
//   const aceEditor = ace.edit(this.editor.nativeElement);
//   aceEditor.getSession().setMode("ace/mode/json");
//   var myObj = this._Customer;
//   var myJSON = JSON.stringify(myObj);
//   aceEditor.session.setValue(myJSON);

// }

exportExcel() {
  let SalesInvoicePOSList = this.GetVolumeDistributionList();
  this.exportUtility.exportExcel(SalesInvoicePOSList, 'Customers', 'xlsx');
}
GetVolumeDistributionList() {
  // if (!this._Saleinvoiceposviews || !this._Saleinvoiceposviews.length)
  //   return;
  let SalesInvoicePOSList = [];
  this.CustomerList = [] = [];
  if (this.ManageCustomersList.length == 0) {
    let volumelist: any = {};
    volumelist["Customer Name"] = "";
    volumelist["Customer Tally ID"] = "";
    volumelist["Company Type"] = "";
    volumelist["Is Transporter"] = "";
    volumelist["PAN No"] = "";
    volumelist["Billing Cycle"] = "";
    volumelist["Status"] = "";

    SalesInvoicePOSList.push(volumelist);
  }
  this.ManageCustomersList.forEach(element => {
    let volumelist: any = {};
    volumelist["Customer Name"] = element.customername;
    volumelist["Customer Tally ID"] = element.tallyid;
    volumelist["Company Type"] = element.companytype;
    volumelist["Is Transporter"] = element.istransporter;
    volumelist["PAN No"] = element.pan;
    volumelist["Billing Cycle"] = element.billingcycle;
    volumelist["Status"] = element.recordstatus;

    SalesInvoicePOSList.push(volumelist);
  });



  return SalesInvoicePOSList;
}
VerifyCustomer()
{
  var customername = this._Customerform.get("customername").value;
  if(customername.length > 0 && customername != '' && customername != undefined)
  {
    this._Customer = this._Customerform.value;
    this._Customer.customername = customername;
    this._CustomerService.VerifyCustomer(this._Customer).subscribe((result) => {
      const resutJSON = JSON.parse(JSON.stringify(result));
      // console.log("save", resutJSON)
      if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
        // this._CustomExceptionService.handleSuccess(usererrors.Saved_Success_00);
        // this.ManageCustomersList = resutJSON.lstCustomer
        // this.reset()
      }
      else {
        this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
        this._Customerform.controls["customername"].setValue('');
      }
    }, error => { this._CustomExceptionService.handleError(error) }

    );
  }
}
}
